module.exports = __webpack_public_path__ + "img/logo8.4f6f5d8e.png";